"use strict";

import _ from "lodash";

var personalMessagingService = function ($stateParams, $q, $rootScope, $cookies) {
    var service = this;

    service.updatePMCookies = function (gaID, accu) {
        /**   	var pm_accu_cookie = $cookies.get('PM-ACCU-TOKEN');
        if(//$rootScope.blueConicData.accu === 'Apple' && 
            (pm_accu_cookie !== null) && (pm_accu_cookie !== accu))
        {
            pm_accu_cookie  = accu;
            $cookies.put('PM-ACCU-TOKEN', pm_accu_cookie, {'path': '/'});

        }

        var pm_plan_cookie = $cookies.get('PM-PLAN-TOKEN');
        if(//$rootScope.blueConicData.accu === 'Apple' && 
            (pm_plan_cookie !== null) && (pm_plan_cookie !== gaID))
        {
            pm_plan_cookie  = gaID;
          //  $cookies.put('PM-PLAN-TOKEN', pm_plan_cookie, {'path': '/'});
           $cookies['PM-PLAN-TOKEN'] = pm_plan_cookie;

        }*/
    };
};

personalMessagingService.$inject = ["$stateParams", "$q", "$rootScope", "$cookies"];
export default personalMessagingService;
